import { useStore } from "../../../context";
import React from "react";
import { navigate } from "@reach/router";
import TagManager from "react-gtm-module";
import logoanai from "../../../images/logos/logoanai.png";

export default () => {
  const { dispatch } = useStore();

  const handleClickRecuperaEstAnai = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        path: "/matricula/anai"
      }
    });
    dispatch({ type:"SET_LOGIN", payload:"A"});
    navigate("/recuperarClaveEst")
  };

  const handleClickOpenEstNuevo = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
        path: "/matricula/nuevo"
      }
    });
    dispatch({ type:"SET_LOGIN", payload:"N"});
    navigate("/recuperarClaveNue")
  };

  return (
    <div className="login-bg">
      <div className="login-card" style={{ maxWidth: 440 }}>
        <img src={logoanai} alt="ANAI Logo" className="login-logo" />
        <div className="login-title">Recuperar Contraseña</div>
        <div className="login-subtitle">
          Seleccione el tipo de usuario
        </div>

        <button
          className="btn-modern btn-primary"
          onClick={handleClickOpenEstNuevo}
        >
          🆕 Para Usuarios Nuevos
        </button>
        <button
          className="btn-modern btn-accent"
          onClick={handleClickRecuperaEstAnai}
        >
          🎓 Para Usuarios con estudiantes ANAI
        </button>
        <button
          className="btn-modern btn-outline"
          style={{ marginTop: 16 }}
          onClick={() => navigate("/")}
        >
          ← Volver al inicio
        </button>

        <div className="modern-copyright">
          {"© " + new Date().getFullYear() + " "}
          <a href="https://anai.edu.ec/" target="_blank" rel="noopener noreferrer">
            Academia Naval Almirante Illingworth
          </a>
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
};
